import React from 'react';
import BuildOrderBtn from '../build-order-btn.jsx';
import TinyRemainItem from './tiny-remain-item.jsx';
import { formatPrice } from '../../../helper/common-helper.js';
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../../intl/helper';
import dishText from '../../../intl/messages/dish';
import commonMessage from '../../../intl/messages/common';
import orderText from '../../../intl/messages/order';

import './tiny-remain.scss';
class TinyRemain extends React.Component {
  static displayName = 'TinyRemain';
  static proptypes = {
    totalPrice: React.PropTypes.number.isRequired,
    changeShowDataItems: React.PropTypes.object.isRequired,
    dishesData: React.PropTypes.array.isRequired,
    multiMarketing: React.PropTypes.array.isRequired,
    dishTypesData: React.PropTypes.array.isRequired,
    takeawayServiceProps: React.PropTypes.object.isRequired,
    outerStyle: React.PropTypes.object,

    showHandleInput: React.PropTypes.func.isRequired,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    showAddItemsFunc: React.PropTypes.func,
  };

  // static defaultProps = { showAddItems: false, showAddItemsButton: true };

  constructor(props) {
    super(props);
    this.state = { showAddItems: false };
    this.includeDate = this.includeDate.bind(this);
    this.formatMultiMarketing = this.formatMultiMarketing.bind(this);
    this.addItems = this.addItems.bind(this);
    this.onBtnTap = this.onBtnTap.bind(this);
    this.formatSearchDishItem = this.formatSearchDishItem.bind(this);
    this.getAddItems = this.getAddItems.bind(this);
    this.hideAddItems = this.hideAddItems.bind(this);
    this.getTinyRemainPart = this.getTinyRemainPart.bind(this);
    this.buildTakeawayServiceRemainShipFeeElement = this.buildTakeawayServiceRemainShipFeeElement.bind(this);
    this.tinyRemain = this.tinyRemain.bind(this);
  }

  componentWillMount() {
    this.marketList = [];
    this.marketFirst = [];
    this.alreadyReduce = 0;
  }

  componentDidMount() {
    document.querySelector('.tiny-cart-left').onclick = () => {
      const { showAddItems } = this.state;
      if (showAddItems) {
        this.setState({ showAddItems: false });
      }
    };
    
  }

  componentWillReceiveProps(nextProps) {
    const { totalPrice } = this.props;
    const length = this.marketList.length;
    if (
      totalPrice &&
      nextProps.totalPrice &&
      length > 0 &&
      totalPrice !== nextProps.totalPrice &&
      this.marketList[length - 1].consumeLimit &&
      nextProps.totalPrice >= this.marketList[length - 1].consumeLimit
    ) {
      this.setState({ showAddItems: false });
    }
  }

  includeDate(item) {
    const myDate = new Date();
    const periodStart = item.periodStart;
    let periodEnd = item.periodEnd;
    if (periodEnd === '00:00:00') {
      periodEnd = '23:59:59';
    }
    const weekdays = item.weekdays.split('');
    const week = myDate.getDay();
    const hours = myDate.getHours();
    const minutes = myDate.getMinutes();
    const seconds = myDate.getSeconds();
    const formatFunc = (number) => {
      if (number < 10) {
        return `0${number}`;
      }
      return number;
    };
    const myTimeFormat = `${formatFunc(hours)}:${formatFunc(minutes)}:${formatFunc(seconds)}`;
    if (weekdays[week] === '1' && myTimeFormat >= periodStart && myTimeFormat <= periodEnd) {
      return true;
    }
    return false;
  }

  formatMultiMarketing(multiMarketing) {
    const { totalPrice } = this.props;
    const filterMultiMarketing = [];
    multiMarketing.forEach(item => {
      if (item.applyProductType === 1 && this.includeDate(item)) { // 针对全部商品
        const obj = {
          consumeLimit: item.consumeLimit,
          type: item.type,
          reduce: item.reduce,
          discount: item.discount,
        };
        filterMultiMarketing.push(obj);
      }
    });
    if (multiMarketing.length === 0) {
      return {
        list: [],
        first: [],
      };
    }
    const getFinalReduce = (item, isTotalPrice) => {
      if (item.type === 1) {
        return item.reduce;
      } else if (item.type === 2) {
        if (isTotalPrice) {
          return (totalPrice - item.discount * totalPrice * 0.1).toFixed(2);
        }
        return (item.consumeLimit - item.discount * item.consumeLimit * 0.1).toFixed(2);
      }
    };

    const reduceRepeat = (array) => {
      const newArray = [];
      array.forEach(item => {
        if (!newArray.find(itemt => itemt.consumeLimit === item.consumeLimit)) {
          newArray.push(item);
        }
      });
      return newArray;
    };

    const sortMultiMarketing = filterMultiMarketing
      .sort((a, b) => {
        if (a.consumeLimit === b.consumeLimit) {
          const finalReduceA = getFinalReduce(a);
          const finalReduceB = getFinalReduce(b);
          return finalReduceB - finalReduceA;
        }
        return a.consumeLimit - b.consumeLimit;
      });

    const minSortFilterMultiMarketing = reduceRepeat(
      sortMultiMarketing
      .filter(item => totalPrice < item.consumeLimit)
      )
      .slice(0, 3);

    const maxSortFilterMultiMarketing = reduceRepeat(
      sortMultiMarketing
      .filter(item => totalPrice >= item.consumeLimit)
      );

    /* 此处计算一共优惠了多少钱 */
    const maxSortFilterMultiMarketingLength = maxSortFilterMultiMarketing.length;
    if (maxSortFilterMultiMarketingLength > 0) {
      this.alreadyReduce = getFinalReduce(maxSortFilterMultiMarketing[maxSortFilterMultiMarketingLength - 1], true);
    } else {
      this.alreadyReduce = 0;
    }

    this.marketList = minSortFilterMultiMarketing;
    this.marketFirst = minSortFilterMultiMarketing.slice(0, 1);
    return {
      list: minSortFilterMultiMarketing,
      first: minSortFilterMultiMarketing.slice(0, 1),
    };
  }

  addItems(evt, bool) {
    evt.stopPropagation();
    evt.preventDefault();
    const { showAddItemsFunc } = this.props;
    if (bool) {
      this.setState({ showAddItems: !this.state.showAddItems });
      if (showAddItemsFunc) {
        showAddItemsFunc();
      }
    }
  }

  onBtnTap(newCount, increment, dishData) {
    const { onOrderBtnTap, onPropsBtnTap } = this.props;
    if (increment) {
      onOrderBtnTap(dishData, increment);
    } else {
      onPropsBtnTap(dishData);
    }
  }

  formatSearchDishItem(dishesData) {
    const { dishTypesData, changeShowDataItems, showHandleInput } = this.props;
    const totalDishArray = [];
    const arrayKeep = [];
    dishTypesData.forEach((dishTypeData, idx) => {
      (dishTypeData.dishIds || []).forEach((dishId, i) => {
        const dishData = dishesData.filter(dish => dish.id === dishId)[0] || null;
        if (!dishData || dishData.proxyDishId) {
          return false;
        }
        if (arrayKeep.indexOf(dishId) !== -1) {
          return false;
        }
        arrayKeep.push(dishId);
        const { sameDishIndexs } = dishData;
        const sameRuleDishList = sameDishIndexs ? sameDishIndexs.map(dishIndex => dishesData[dishIndex]) : null;
        const isClear = sameRuleDishList ? sameRuleDishList.every(dish => { if (dish) return dish.clearStatus; }) : dishData.clearStatus;
        const orderBtn = (
          <BuildOrderBtn
            dishData={dishData}
            sameRuleDishList={sameRuleDishList}
            isClear={isClear}
            changeShowDataItems={changeShowDataItems}
            showHandleInput={showHandleInput}
            onBtnTap={this.onBtnTap}
            showHandleDishCount={() => {}}
          />
        );
        totalDishArray.push(
          <TinyRemainItem
            key={dishData.id}
            dishName={dishData.name}
            dishMarketPrice={dishData.marketPrice}
            orderBtn={orderBtn}
            dishData={dishData}
          />
        );
        return true;
      });
      return true;
    });
    return totalDishArray;
  }

  getAddItems(filterDishesDataWithPrice, sameRuleDishList) {
    return (
      <div className="tiny-remainaddon o-fz--15 o-ta--l">
        <ul className="tiny-remainaddon-ul">
          {this.formatSearchDishItem(filterDishesDataWithPrice)}
        </ul>
      </div>
    );
  }

  hideAddItems() {
    this.setState({ showAddItems: false });
  }

  getTinyRemainPart(formatMultiMarketing, totalPrice, showAddItems, filterDishesDataWithPrice) {
    let formatMultiMarketingPart = '';
    let tinyRemainCutPart = '';
    let addItemsPart = '';
    let tinyRemainHoverPart = '';
    if (this.props.isHDL) {
      if (sessionStorage.getItem('reducePrice') && sessionStorage.getItem('reducePrice') > 0) {
        formatMultiMarketingPart = [<i key={1} style={{ margin: '0 5px' }}>{formatMessage(commonMessage.commondiscount)}<span className="price">{sessionStorage.getItem('reducePrice')}</span></i>];
      } else if (totalPrice == 0 && this.marketList && this.marketList.consumeLimit) {
        formatMultiMarketingPart = [<span>{formatMessage(orderText.full)}<span className="tiny-remain-highlight">{this.marketList.consumeLimit}</span>{formatMessage(orderText.reduce)}<span className="tiny-remain-highlight">{this.marketList.reduce}</span></span>]
      } else if (formatMultiMarketing.length === 0) {
        if (this.alreadyReduce) {
          formatMultiMarketingPart = [<i key={1} style={{ margin: '0 5px' }}>{formatMessage(dishText.dishCartCut)}<span className="price">{this.alreadyReduce}</span></i>];
        } else {
          return false;
        }
      } else {
        formatMultiMarketingPart = formatMultiMarketing.map((item, index) => {
          let word = '';
          let wholeWord = '';
          if (item.type === 1) {
            word = formatMessage(dishText.dishCartCutNow, { currency:sessionStorage.getItem('currency'), reduce:item.reduce });
          } else if (item.type === 2) {
            word = formatMessage(dishText.dishCartGetDiscount, { discount:item.discount });
          }
          wholeWord = <i>{formatMessage(orderText.full)}<span className="tiny-remain-highlight">{item.consumeLimit}</span>{word}</i>;
          if (totalPrice) {
            const alreadyReduceWord = this.alreadyReduce ? `${formatMessage(dishText.dishCartCut)}${sessionStorage.getItem('currency')}${this.alreadyReduce}` : '';
            wholeWord = word = (
              <i>
                {alreadyReduceWord} {formatMessage(orderText.buyMore)}<span className="tiny-remain-highlight price">{(item.consumeLimit - totalPrice).toFixed(2)}</span>{word}
              </i>
            );
          }
          return <i key={index} style={{ margin: '0 5px' }}>{wholeWord}</i>;
        });

        // tinyRemainCutPart
        if (
          totalPrice &&
          formatMultiMarketing[0] && formatMultiMarketing[0].consumeLimit - totalPrice < 15 &&
          !showAddItems &&
          filterDishesDataWithPrice.length
        ) {
          tinyRemainCutPart = <i className="tiny-remain-cut"><FormattedMessage {...dishText.dishgotoAddOn} /> ></i>;
        }
        // addItemsPart
        if (showAddItems) {
          addItemsPart = this.getAddItems(filterDishesDataWithPrice);
        }
        // tinyRemainHoverPart
        if (showAddItems) {
          tinyRemainHoverPart = <div className="tiny-remain-hover" onTouchTap={this.hideAddItems}></div>;
        }
      }
    } else {
      if (formatMultiMarketing.length === 0) {
        if (this.alreadyReduce) {
          formatMultiMarketingPart = [<i key={1} style={{ margin: '0 5px' }}>{formatMessage(dishText.dishCartCut)}<span className="price">{this.alreadyReduce}</span></i>];
        } else {
          return false;
        }
      } else {
        formatMultiMarketingPart = formatMultiMarketing.map((item, index) => {
          let word = '';
          let wholeWord = '';
          if (item.type === 1) {
            word = formatMessage(dishText.dishCartCutNow, { currency:sessionStorage.getItem('currency'), reduce:item.reduce });
          } else if (item.type === 2) {
            word = formatMessage(dishText.dishCartGetDiscount, { discount:item.discount });
          }
          wholeWord = <i>{formatMessage(orderText.full)}<span className="tiny-remain-highlight">{item.consumeLimit}</span>{word}</i>;
          if (totalPrice) {
            const alreadyReduceWord = this.alreadyReduce ? `${formatMessage(dishText.dishCartCut)}${sessionStorage.getItem('currency')}${this.alreadyReduce}` : '';
            wholeWord = word = (
              <i>
                {alreadyReduceWord} {formatMessage(orderText.buyMore)}<span className="tiny-remain-highlight price">{(item.consumeLimit - totalPrice).toFixed(2)}</span>{word}
              </i>
            );
          }
          return <i key={index} style={{ margin: '0 5px' }}>{wholeWord}</i>;
        });
  
        // tinyRemainCutPart
        if (
          totalPrice &&
          formatMultiMarketing[0] && formatMultiMarketing[0].consumeLimit - totalPrice < 15 &&
          !showAddItems &&
          filterDishesDataWithPrice.length
        ) {
          tinyRemainCutPart = <i className="tiny-remain-cut"><FormattedMessage {...dishText.dishgotoAddOn} /> ></i>;
        }
        // addItemsPart
        if (showAddItems) {
          addItemsPart = this.getAddItems(filterDishesDataWithPrice);
        }
        // tinyRemainHoverPart
        if (showAddItems) {
          tinyRemainHoverPart = <div className="tiny-remain-hover" onTouchTap={this.hideAddItems}></div>;
        }
      }
    }
    return (
      <div className="tiny-remain o-fz--12 o-ta--c" style={this.props.outerStyle}>
        <div
          className="tiny-remain-inner"
          onTouchTap={
            (evt) => this.addItems(
              evt,
              totalPrice &&
              formatMultiMarketing[0] && formatMultiMarketing[0].consumeLimit - totalPrice < 15 &&
              !showAddItems && filterDishesDataWithPrice.length,
            )
          }
        >
          {formatMultiMarketingPart}
          {tinyRemainCutPart}
        </div>
        {addItemsPart}
        {tinyRemainHoverPart}
      </div>
    );
  }

  buildTakeawayServiceRemainShipFeeElement(totalPrice, takeawayServiceProps) {
    if (!takeawayServiceProps || !takeawayServiceProps.shipmentFee) {
      return false;
    }
    const shipFreePrice = takeawayServiceProps.shipFreePrice; // 减免配送费金额
    if (shipFreePrice === 9999999999) {
      return 0;
    }
    const remainShipmentFee = formatPrice(shipFreePrice - totalPrice);
    return remainShipmentFee > 0 ? remainShipmentFee : 0;
  }

  tinyRemain() {
    const { totalPrice, takeawayServiceProps, multiMarketing, dishesData } = this.props;
    const { showAddItems } = this.state;
    const filterDishesDataWithPrice = dishesData.filter(item => item.marketPrice <= 10);
    const takeawayServiceRemainShipFee = this.buildTakeawayServiceRemainShipFeeElement(totalPrice, takeawayServiceProps);
    let formatMultiMarketing = [];
    if (totalPrice) {
      formatMultiMarketing = this.formatMultiMarketing(multiMarketing).first;
    } else {
      formatMultiMarketing = this.formatMultiMarketing(multiMarketing).list;
    }

    if (takeawayServiceRemainShipFee > 0 && takeawayServiceRemainShipFee < 1000) {
      return (
        <div className="tiny-remain tiny-remain-inner o-fz--12 o-ta--c" style={this.props.outerStyle}>
          {
            takeawayServiceRemainShipFee === takeawayServiceProps.shipFreePrice ? formatMessage(orderText.full) : formatMessage(orderText.less)
          }
          <span className="tiny-remain-orange price">{takeawayServiceRemainShipFee}</span>
          {formatMessage(orderText.can)}<span className="tiny-remain-orange">{formatMessage(dishText.dishCartNoSendPay)}</span>
        </div>
      );
    }
    // if (!takeawayServiceRemainShipFee && formatMultiMarketing && formatMultiMarketing.length >= 0) {
      return this.getTinyRemainPart(formatMultiMarketing, totalPrice, showAddItems, filterDishesDataWithPrice);
    // }

    // return null;
  }

  render() {
    return this.tinyRemain();
  }
}

export default TinyRemain;



// WEBPACK FOOTER //
// ./src/component/dish-menu/cart/tiny-remain.jsx